import { useRef } from "react";
import { Link } from "react-router-dom";
import { BookOpenText, Gear } from "@phosphor-icons/react";
import { useProgressStore } from "../../stores/progressStore";
import { Button } from "../ui/Button";
import type { DialogHandle } from "../ui/Dialog";
import styles from "./Header.module.css";
import { SettingsDialog } from "../../../ui/SettingsDialog";
import { ReferenceDialog } from "../../../ui/ReferenceDialog";

interface HeaderProps {
  hidden?: boolean;
}

export function Header({ hidden = false }: HeaderProps) {
  const currentUnit = useProgressStore(
    (s) => s.courses[s.activeCourse].currentUnit,
  );
  const currentLesson = useProgressStore(
    (s) => s.courses[s.activeCourse].currentLesson,
  );

  const settingsRef = useRef<DialogHandle>(null);
  const referenceRef = useRef<DialogHandle>(null);

  return (
    <header
      className={[styles.header, hidden ? styles.hidden : ""]
        .filter(Boolean)
        .join(" ")}
    >
      <Link to="/" className={styles.logo} aria-label="Stanford Karel home">
        <img
          src="/images/logo.png"
          alt="Stanford Karel"
          className={styles.logoMark}
          width={116}
          height={20}
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
        />
      </Link>

      <h1 className={styles.title}>
        Unit {currentUnit} Lesson {currentLesson}
      </h1>

      <nav className={styles.nav}>
        <Button
          variant="secondary"
          icon={<BookOpenText size={16} />}
          onClick={() => referenceRef.current?.open()}
        >
          Reference
        </Button>
        <Button
          variant="secondary"
          icon={<Gear size={16} />}
          aria-label="Settings"
          title="Settings"
          onClick={() => settingsRef.current?.open()}
        >
          Settings
        </Button>
      </nav>

      {!hidden && <SettingsDialog ref={settingsRef} />}
      <ReferenceDialog ref={referenceRef} />
    </header>
  );
}
